<template>
    <v-layout row xs12 >
        <Loading :value="loading" ></Loading>
        <v-dialog
                v-model="dialogAjoutFournisseur"
                max-width="100%">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Ajouter/Editer un nouveau fournisseur</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeForm()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <el-form id="formFour" :rules="rules" label-position="top" ref="formFour"  :model="formFour" class="demo-ruleForm" >
                    <v-layout row wrap class="text-xs-center text-sm-left">
                        <!--image-->
                        <v-flex xs12 sm3  class="text-xs-center">
                            <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="logoFour" alt="avatar"></v-avatar><br/>
                            <input name="photo" type="file" style="display:none" ref="fileLogo" accept="image/*" @change="onFileImageLogoPicked"/>
                            <v-btn color="primary" class="white--text" required @click.native="$refs.fileLogo.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn><br/>
                            <div class="font-weight-thin" >Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale</div>
                        </v-flex>

                        <!--Formulaire-->
                        <v-flex xs12  sm9>

                                <el-row  :gutter="10" >
                                    <!--/CHAMPS FOURNISSEUR ENTREPRISE-->
                                    <el-col  :xs="24" :sm="12" :md="6" v-if="typeFour == 0 " >
                                        <div>
                                            <el-form-item
                                                    label="Raison social" prop="raison">
                                                <el-input placeholder="Saisir"    v-model="formFour.raison"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12"  :md="6" v-if="typeFour == 0 " >
                                        <div>
                                            <el-form-item
                                                    label="forme juridique" prop="formJuridique">
                                                <el-input placeholder="Saisir"    v-model="formFour.formJuridique"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12"  :md="6" v-if="typeFour == 0" >
                                        <div>
                                            <el-form-item
                                                    label="Registre de commerce" prop="registreCommerce">
                                                <el-input placeholder="Saisir"    v-model="formFour.registre"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>



                                    <el-col :xs="24" :sm="12" :md="6"  >
                                        <div>
                                            <el-form-item
                                                    label="Type fournisseur" prop="typeFour">
                                                <el-select clearable filterable v-model="formFour.typeFour" placeholder="Selectionnez"  style="width:100%">
                                                    <el-option v-for="(item,index) in listeTypeFour" :key=index :label="item.libelle" :value="item.id"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12"  :md="6" >
                                        <div>
                                            <el-form-item
                                                    label="Corps de métier" prop="corpsMetier">
                                                <el-select clearable allow-create filterable v-model="formFour.corpsMetier" placeholder="Selectionnez"    style="width:100%">
                                                    <el-option v-for="(item,index) in listeCorpsMetier" :key=index :label="item.libelle" :value="item.libelle"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12" :md="6" >
                                        <div>
                                            <el-form-item
                                                    label="Civilité/Représentant légal" prop="civilite">
                                                <el-select clearable filterable v-model="formFour.civilite" placeholder="Selectionnez"  style="width:100%">
                                                    <el-option v-for="(item,index) in listeCivilite" :key=index :label="item.libelle" :value="item.libelle"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12" :md="6"  >
                                        <div>
                                            <el-form-item
                                                    label="Nom/Représentant légal" prop="nom">
                                                <el-input placeholder="Saisir"    v-model="formFour.nom"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12" :md="6"  >
                                        <div>
                                            <el-form-item
                                                    label="Prénom(s)/Représentant légal" prop="prenom">
                                                <el-input placeholder="Saisir"    v-model="formFour.prenom"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <!-- <el-col :xs="24" :sm="12"  :md="6" >
                                        <div>
                                            <el-form-item
                                                    label="Email" prop="email">
                                                <el-input placeholder="Saisir"  v-model="formFour.email"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col> -->

                                    <el-col :xs="24" :sm="12" :md="6"  >
                                        <div>
                                            <el-form-item
                                                    style="width:100%"
                                                    label="Date de naissance/création" prop="dateNais">
                                                <el-date-picker
                                                        format="d-MM-yyyy"
                                                        v-model="formFour.dateNais"
                                                        placeholder="Date de naissance"
                                                        type="date"
                                                        style="width:100%"
                                                >
                                                </el-date-picker>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12" :md="6"  v-show="typeFour == 1"  >
                                        <div>
                                            <el-form-item
                                                    style="width:100%"
                                                    label="Lieu de naissance" prop="lieuNais">
                                                <el-input placeholder="Saisir"    v-model="formFour.lieuNais"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12" :md="6" >
                                        <div>
                                            <el-form-item
                                                    label="Nature de la pièce" prop="naturePiece">
                                                <el-select clearable allow-create filterable v-model="formFour.naturePiece" placeholder="Selectionnez"  style="width:100%">
                                                    <el-option v-for="(item,index) in listeNaturePiece" :key=index :label="item.libelle" :value="item.libelle"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12" :md="6"   >
                                        <div>
                                            <el-form-item
                                                    label="Numéro de la pièce" prop="numPiece">
                                                <el-input placeholder="Saisir" v-model="formFour.numPiece"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col  :xs="24" :sm="12" :md="6" v-if="typeFour == 1" >
                                        <div>
                                            <el-form-item
                                                    style="width:100%"
                                                    label="Date de délivrance" prop="dateDeliv">
                                                <el-date-picker
                                                        format="d-MM-yyyy"
                                                        v-model="formFour.dateDeliv"
                                                        placeholder="Selectionnez"
                                                        type="date"
                                                        style="width:100%"
                                                >
                                                </el-date-picker>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12" :md="6" v-if="typeFour == 1"  >
                                        <div>
                                            <el-form-item

                                                    label="Date d'expiration" prop="dateExpir">
                                                <el-date-picker
                                                        format="d-MM-yyyy"
                                                        v-model="formFour.dateExpir"
                                                        placeholder="Selectionnez"
                                                        type="date"
                                                        style="width:100%"
                                                >
                                                </el-date-picker>
                                            </el-form-item>
                                        </div>
                                    </el-col>




                                    <el-col :xs="24" :sm="12" :md="6"  >
                                        <div>
                                            <el-form-item
                                                    label="Domicile/Siège social" prop="domicile">
                                                <el-input placeholder="Saisir"    v-model="formFour.domicile"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12" :md="6" v-if="typeFour == 1"  >
                                        <div>
                                            <el-form-item
                                                    label="Nationalité" prop="nationalite">
                                                <el-input placeholder="Saisir"    v-model="formFour.nationalite"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>


                                    <el-col :xs="24" :sm="12" :md="6" >
                                        <div>
                                            <el-form-item
                                                    label="Profession" prop="profession">
                                                <el-input placeholder="Saisir"    v-model="formFour.profession"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12" :md="6"  >
                                        <div>
                                            <el-form-item
                                                    label="Contact" prop="contact">
                                                <el-input placeholder="Saisir"    v-model="formFour.contact"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>

                                    <el-col :xs="24" :sm="12" :md="6"  >
                                        <div>
                                            <el-form-item
                                                    label="Service fournit" prop="service">
                                                <el-input placeholder="Description"  :rows="6" type="textarea"  v-model="formFour.service"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                </el-row>
                        </v-flex>

                        <!--Bouton valider-->
                        <v-flex xs12 sm12 align-self-end  >
                            <v-divider ></v-divider>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="pr-1"  md2   offset-md8>
                                    <v-btn block @click="closeForm()" color="grey"  dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                                </v-flex>

                                <v-flex xs12  sm6 md2  >
                                    <v-tooltip top>
                                        <v-btn slot="activator" icons block color="green" @click="saveForm()" dark>Enregistrer <v-icon right></v-icon></v-btn>Enregistrer
                                        <!-- <span>Après l'enregistrement le fournisseur recevra ses identifiants de connection par mail et sms</span> -->
                                    </v-tooltip>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    </el-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import Loading from '@/components/Loading';
    export default {
        name: "formAjoutFour",
        components: {Loading},
        props:{
            typeFour:{
                type: Number,
                default: 1 // 1=>particuliers, 0=>Entreprise
            },
            idFour:
            {
                type: Number,
                default: null,
            },
            show:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),


                logoFour: "/static/img-doc.png",
                fileLogo: "",
                etatModif: null,
                dialogAjoutFournisseur: false,
                formFour:{
                    nom:"",
                    raison:"",
                    formJuridique:"",
                    registre:"",
                    typeFour:"",
                    corpsMetier:"",
                    civilite:"",
                    prenom:"",
                    email:"",
                    dateNais:"",
                    lieuNais:"",
                    naturePiece:"",
                    numPiece:"",
                    dateDeliv:"",
                    dateExpir:"",
                    contact:"",
                    profession:"",
                    domicile:"",
                    nationalite:"",
                    service:"",
                    listesFichier:[],
                },
                listeTypeFour:[
                    {
                        id:1,
                        libelle: "Fournisseur"
                    },
                    {
                        id:2,
                        libelle: "Prestataire"
                    }
                ],
                listeCivilite:[
                    {
                        id:1,
                        libelle: "Monsieur"
                    },
                    {
                        id:2,
                        libelle: "Madame"
                    },
                    {
                        id:3,
                        libelle: "Mademoiselle"
                    }
                ],
                listeNaturePiece:[
                    {
                        id:1,
                        libelle: "CNI"
                    },
                    {
                        id:2,
                        libelle: "PASSEPORT"
                    },
                    {
                        id:3,
                        libelle: "PERMIS DE CONDUIRE"
                    },
                    {
                        id:4,
                        libelle: "ATTESTATION"
                    }
                ],
                listeCorpsMetier:[],
                loading: false,
                urlFour: "",
                rules:{
                    typeFour: [
                        { required: true, message: 'Veuillez selectionnez un type fournisseur', trigger: 'blur' }
                    ],
                    corpsMetier: [
                        {required:true, message: "Veuillez saisir ou selectionnez un corps de métier",trigger: 'blur' }
                    ],
                    nom: [
                        {required:true, message: "Veuillez  saisir un nom",trigger: 'blur' }
                    ],
                    prenom: [
                        {required:true, message: "Veuillez  saisir un prénom",trigger: 'blur' }
                    ],
                    // email: [
                    //     {type: 'email', required:true, message: "Veuillez  saisir une adresse mail",trigger: 'blur' }
                    // ],
                    civilite: [
                        { required: true, message: 'Veuillez selectionnez une civilité', trigger: 'blur' }
                    ],
                    dateNais: [
                        {  required: true, message: 'Veuillez selectionnez une date', trigger: 'blur' }
                    ],
                    domicile: [
                        {  required: true, message: 'Veuillez saisir une adresse', trigger: 'blur' }
                    ],
                    // naturePiece: [
                    //     {  required: true, message: 'Veuillez selectionnez votre type de pièce', trigger: 'blur' }
                    // ],
                    // numPiece: [
                    //     {  required: true, message: 'Veuillez saisir le numéro de  la pièce', trigger: 'blur' }
                    // ],
                    contact: [
                        {  required: true, message: 'Veuillez saisir un contact', trigger: 'blur' }
                    ],
                    service: [
                        {  required: true, message: 'Veuillez saisir une description', trigger: 'blur' }
                    ],
                },
            }
        },
        watch:{
            show: function(newValue,oldValue){
                if(newValue == true){
                    this.dialogAjoutFournisseur =true;
                    this.resetForm();
                    if(this.idFour == null){
                        this.urlFour = this.domaine + 'fournisseur/create';
                    }else
                        {
                        this.urlFour = this.domaine + 'fournisseur/update';
                        this.loadFournisseur();
                    }
                    this.loadMetier();

                }else{
                    this.dialogAjoutFournisseur =false;
                }

            }
        },
        methods: {
            loadFournisseur(){
                 let url = this.domaine + 'fournisseur/' + this.idFour + '/show'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        let details = response.body.fournisseur
                        this.etatModif =0
                         this.formFour={
                                nom: details.nom,
                                raison: details.raison,
                                formJuridique: details.formJuridique,
                                registre: details.registreComm,
                                registreCommerce: details.registre,
                                typeFour: details.typeFour,
                                corpsMetier: details.metierLibel,
                                civilite: details.civilite,
                                prenom: details.pren,
                                email: details.email,
                                dateNais: details.dateNais,
                                lieuNais: details.lieuNais,
                                naturePiece: details.naturePiece,
                                numPiece: details.numPiece,
                                dateDeliv: details.dateDeliv,
                                dateExpir: details.dateExpir,
                                contact: details.contact,
                                profession: details.profession,
                                domicile: details.domicile,
                                nationalite: details.nationalite,
                                service: details.service,
                                listesFichier:[],
                            },
                            this.logoFour = details.url
                        this.loading = false
                    }
                })
            },
            //  loadFournLimit () {
            //     this.loading = true
            //     let url = this.domaine + 'fournisseur/indexRecent'
            //     this.$http.get(url).then(response => {
            //         if (response.body) {
            //             this.listFour = response.body.fournisseur
            //             this.listFourFinal = response.body.fournisseur
            //             this.statAllFour = response.body.stats
            //             this.comboFournisseur = response.body.combofournisseur
            //             this.statAllFactureFour = response.body.statsFact
            //             this.nbrComAll = response.body.nbrCom
            //             this.nbrFactAll = response.body.nbrFact
            //             this.nbrLivrAll = response.body.nbrLivr
            //             this.depenseAll = response.body.coutTotal
            //             this.loading = false
            //         }
            //     })
            // },

            loadMetier()
            {
                    if(this.listeCorpsMetier.length > 0){
                        return;
                    }
                    let urlMetier = this.domaine + "fournisseur/liste/metier";
                    this.$http.get(urlMetier).then(
                        resp=>{
                            this.listeCorpsMetier = resp.body.listeMetier;
                        }, error=>{
                            this.loading = false;
                            this.$message.error("Une erreur est survenue lors de la recherche du corps de métier")
                        }
                    );
            },

            saveForm(){

                this.$refs["formFour"].validate((valid) => {

                    if (valid) {
                        this.loading = true;
                        let form = document.getElementById('formFour')
                        let data = new FormData(form);
                        data.append('dataFour', JSON.stringify(this.formFour)  )
                        data.append('idUser', this.user.id)
                        data.append('idFour', this.idFour)
                        data.append('typeParEntr', this.typeFour);
                        this.$http.post(this.urlFour, data).then( response=>
                        {
                            this.loading = false;
                            if(response.body.code == 5){
                                this.$alert(response.body.message, 'ENREGISTREMENT', {
                                    confirmButtonText: 'OK',
                                    callback: action => {
                                        this.closeForm()
                                    }
                                });
                                return;
                            }else {
                                this.$alert(response.body.message, "ENREGISTREMENT", {
                                    confirmButtonText: 'OK',
                                    callback: action => {
                                    }
                                });
                                return;
                            }

                        }, error=>{
                            this.loading = false;
                            this.$message.error("Une erreur est survenue lors de l'enregistrement du fournisseur")

                        } );


                    }
                });
            },
            resetForm() {
                this.logoFour = "/static/img-doc.png";
                this.formFour.formJuridique = "";
                this.formFour.registre = "";
                this.formFour.raison = "";
                this.formFour.typeFour = "";
                this.$refs["formFour"].resetFields();
            },
            closeForm(){
                //this.dialogAjoutFournisseur = false;
                this.$emit("close")
                this.resetForm();
            },
            //enregistrement des images
            onFileImageLogoPicked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }
                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.logoFour = fileReader.result
                })
                fileReader.readAsDataURL(files[0])
                this.logoFour = files[0]

            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tierce/formAjoutFour.vue